export default __webpack_public_path__ + "static/shade-c418ff4079c9fa09aa7904073901deb0.png";